import {useMutation} from "@tanstack/react-query";
import {createAuthUser} from "../services/UserService";

// Create a user via the authz-aware endpoint (POST /api/v3/auth/users). See TMMFX-2170.
export function useAuthUserCreate() {
    return useMutation({
        mutationFn: createAuthUser,
    });
}
